import {isActivity, isSticker, isText, isImage, isLineText} from './shapes-detectors.util';

function setShapeValue(cell, value): string {
  const html = cell.value;

  if (
    cell.edge ||
    isLineText(cell) ||
    isActivity(cell) ||
    isText(cell) ||
    isImage(cell) ||
    isSticker(cell)
  ) {
    const markerBegin = '<!--contentbegin-->';
    const markerEnd = '<!--contentend-->';

    const markerBeginIndex = html.indexOf(markerBegin);
    const markerEndIndex = html.indexOf(markerEnd);

    const editingPrefix = html.slice(0, markerBeginIndex);
    const editingSuffix = html.slice(markerEndIndex + markerEnd.length, html.length);

    return [editingPrefix, markerBegin, value, markerEnd, editingSuffix].join('');
  }
}

export {setShapeValue};
